<dx-select-box
  valueExpr="field"
  label="{{ 'Feld' | translate }}"
  width="100%"
  placeholder="{{ 'Feld auswählen' | translate }}"
  [displayExpr]="getFieldDisplayExpr"
  [showClearButton]="true"
  [items]="fieldList"
  [searchEnabled]="true"
  [(value)]="pimField.field"
  (onSelectionChanged)="update()"
/>

<dx-switch *ngIf="pimField.fieldType != 'udx' && hasSystem"
           style="margin-left: 25px; align-self: center;"
           [(value)]="pimField.useSequence"
           (onValueChanged)="update()"/>

<dx-number-box *ngIf="hasSystem"
               class="flex-grow-1 np-highlight"
               label="{{ (pimField.useSequence ? 'Reihenfolgennummer' : 'Sortiernummer') | translate }}"
               [value]="parseInt(pimField.systemKey)"
               (onValueChanged)="onOrderChanged($event)"/>

<dx-text-box class="flex-grow-1 np-highlight"
             label="{{ 'Filter (Beschreibung)' | translate }}"
             [(value)]="descriptionFilter"
             (onValueChanged)="update()"/>
